module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAsCAYAAAANUxr1AAABU0lEQVRYR+2ZPUoEMRiGn1cExSPYeQD3Bjb2ouV2doIWnsBTWCjYCBa2ulhuZyO27gFs7LyAA2okoBDCSOZbE8hKpky+n5dnvh+YkXNuHbgEtoFl8jzvwD2wL+nFElLOuRtgz+JksJ1IMsX2gt6AFUMSi2knadXi4AU5i4PVVpIsPk1QilYjNA+hZ+AgctwBjoMzf+/twmfalyxHUc8kjcLgzrlD4Cw4G0maRTa93doE/VD6bZ5VRwi4SBUy8AE8Ald9bZ+1qAeICU1Ois8ho6DX2gTRBKVe4UIQKtVlp8BdRMiPhI3wrI9Q1tURJDuSdB6tmydgswn6JvB/CFVX1KlRUfR+IeZQUQKp4I3QPISq67K2Otou++suq66oU51Z9L4NxhTeRmgIoZKfhVP54/vOv7JbYNfqWch+4gX5XwvXwBawlCmR/7zSAWsD430CD8D4CyIWfuxbby3FAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo4.png
// module id = BIsI
// module chunks = 1